import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Challenge } from 'src/types/shared/Challenge';

export const postMarkChallengeAsReadyForAssessmentRequest = createAction(
    'postMarkChallengeAsReadyForAssessmentRequest',
);
export const postMarkChallengeAsReadyForAssessmentSuccess = createAction<Challenge>(
    'postMarkChallengeAsReadyForAssessmentSuccess',
);
export const postMarkChallengeAsReadyForAssessmentFailure = createAction(
    'postMarkChallengeAsReadyForAssessmentFailure',
);

export const postMarkChallengeAsReadyForAssessment = (
    challengeID: number,
    revert = false,
) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(postMarkChallengeAsReadyForAssessmentRequest());
    try {
        const { data }: { data: Challenge } = await api.post(
            `admin/challenges/${challengeID}/ready-for-assessment`,
            {},
            { revert },
        );

        dispatch(postMarkChallengeAsReadyForAssessmentSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, postMarkChallengeAsReadyForAssessmentFailure, e);
    }
};
